export const SHOW_TARGET_PRICE = 'targetPrice.show';
export const C2C_TARGET_PRICE_SHOW = 'c2cTargetPrice.show';
export const SHOW_OFFER_PRICE = 'offerPrice.show';
export const AVG_MARKET_PRICE_SHOW = 'avgMarketPrice.show';
export const SHOW_DRIVER_MENU = 'driverMenu.show';
export const SHOW_LOCATION_MENU = 'locationMenu.show';
export const SHOW_MASTER_DATA_MENU = 'masterDataMenu.show';
export const SHOW_VENDOR_ACTIVE = 'vendorActive.show';
export const SHOW_MAKE = 'make.show';
export const SHOW_INVENTORY_TYPE = 'inventoryType.show';
export const SHOW_INVENTORY_SOURCE = 'inventorySource.show';
export const SHOW_INVENTORY_SOURCE_IN_SEARCH = 'inventorySourceSearch.show';
export const SHOW_INVENTORY_SOURCE_TYPE = 'inventorySourcetype.show';
export const SHOW_INVENTORY_SALE_CHANNEL = 'inventorySaleChannel.show';
export const SHOW_BULK_UPLOAD = 'bulkUpload.show';
export const SHOW_RESERVE_BUTTON = 'reserveButton.show';
export const SPLIT_SLOT_TIME = 'slotTime.split';
export const SHOW_PIN_CODE_TAB = 'pinCodeTab.show';
export const SHOW_INTERCITY_TAB = 'intercityTab.show';
export const SHOW_INVENTORY_QR_CODE = 'inventoryQRCode.show';
export const SHOW_INSPECTION_TAB = 'inspectionTab.show';
export const SHOW_LISTING_PREVIEW_TAB = 'listingPreviewTab.show';
export const SHOW_INVENTORY_OTHER_DETAILS_TAB =
  'SHOW_INVENTORY_OTHER_DETAILS_TAB';
export const SHOW_INVENTORY_STAGE = 'inventoryStage.show';
export const SHOW_PARKING_SLOT = 'parkingSlot.show';
export const SHOW_RUNNING_CONDITION = 'runningCondition.show';
export const APPEND_CITY_CODE = 'Append city code while searching locations';
export const SHOW_OFFLINE_DRIVER_TYPES = 'offlineDriverTypes.show';
export const SHOW_TOUCH_POINT_DROPDOWN =
  'Show touch point dropdown while creating pickup requests';
export const REMOVE_DEALER_DROPDOWN =
  'Remove dealer from drop down shown while creating pickup requests';
export const SHOW_CORPORATE_OFFICE = 'SHOW_CORPORATE_OFFICE';
export const GET_EXTERNAL_DELIVERY = 'Checks for external delivery allowed api';
export const SEARCH_INSPECTION_DETAILS = 'Search inspection detail api';
export const SEARCH_PAYMENT_STATUS = 'SEARCH_PAYMENT_STATUS';
export const SHOW_CAR_BOOKED_CONFIRMATION =
  'Show car booked confirmation message';
export const SHOW_PRICE_LOCK = 'Show price lock for automatic updates';
export const RESTRICT_DATE =
  'Restrict future dates for 2 days in date calendars';
export const SHOW_BROKEN_CAR_MESSAGE = 'Show broken car message';
export const BLOCK_OUT_DELIVERY =
  'Block out for delivery if there is no active booking';
export const USE_SLOT_PLANNER = 'USE_SLOT_PLANNER';
export const SHOW_PICKUP_CONTACT_ON_STOCKOUT =
  'SHOW_PICKUP_CONTACT_ON_STOCKOUT';
export const SHOW_DA_CONTACT_ON_STOCKOUT = 'SHOW_DA_CONTACT_ON_STOCKOUT';
export const SHOW_PICKUP_CONTACT_ON_PICKUP = 'SHOW_PICKUP_CONTACT_ON_PICKUP';
export const SHOW_DA_CONTACT_ON_PICKUP = 'SHOW_DA_CONTACT_ON_STOCKOUT';
export const SHOW_KEY_MANAGEMENT_TAB = 'SHOW_KEY_MANAGEMENT_TAB';
export const SHOW_CREATED_AT_FILTER = 'createdAt.show';
export const SHOW_HOW_TO_REACH = 'howToReach.show';
export const SHOW_LOCALITY = 'SHOW_LOCALITY';
export const SHOW_SOLD = 'sold.show';
export const SHOW_DELIVERED = 'delivered.show';
export const SHOW_STOCKOUT_REASON_FILTER = 'SHOW_STOCKOUT_REASON_FILTER';
export const SHOW_REGISTRATION_NUMBER = 'RegistrationNumber.show';
export const SHOW_ADDRESS_IN_THAI = 'AddressInThai.show';
export const SHOW_INVENTORY_SUBSTAGE = 'SHOW_INVENTORY_SUBSTAGE';
export const SHOW_INVENTORY_STAGE_REMARKS = 'SHOW_INVENTORY_STAGE_REMARKS';
export const SHOW_ROUND_TRIP_CHECK = 'SHOW_ROUND_TRIP_CHECK';
export const HIDE_PINCODE_IN_ADDRESS = 'HIDE_PINCODE_IN_ADDRESS';
export const SHOW_EDIT_MOVEMENT = 'SHOW_EDIT_MOVEMENT';
export const SHOW_ROAD_TAX = 'SHOW_ROAD_TAX';
export const SHOW_ROAD_TAX_EXPIRY_DATE = 'SHOW_ROAD_TAX_EXPIRY_DATE';
export const SHOW_GPS_TRACKER_NO = 'SHOW_GPS_TRACKER_NO';
export const SHOW_SOURCING_CANCELLATION = 'SHOW_SOURCING_CANCELLATION';
export const SHOW_DEALER_OPTIONAL = 'SHOW_DEALER_OPTIONAL';
export const SHOW_PINCODE_FIELD = 'SHOW_PINCODE_FIELD';
export const SHOW_PMS_FIELD = 'SHOW_PMS_FIELD';
export const USE_BACK_DATED_PICKUP = 'USE_BACK_DATED_PICKUP';
export const SHOW_LOCUS_ID_IN_OFFLINE_VENDOR =
  'SHOW_LOCUS_ID_IN_OFFLINE_VENDOR';
export const SHOW_REASON_IN_OFFLINE_VENDOR = 'SHOW_REASON_IN_OFFLINE_VENDOR';
export const SHOW_COURTESY_CAR = 'SHOW_COURTESY_CAR';
export const SHOW_RIDER_PERSONA_ID = 'SHOW_RIDER_PERSONA_ID';
export const RESTRICT_ADDRESS_CHAR_COUNT = 'RESTRICT_ADDRESS_CHAR_COUNT';
export const SHOW_STOCK_ID = 'SHOW_STOCK_ID';
export const SHOW_PARKED_DATE_FILTER = 'SHOW_PARKED_DATE_FILTER';
export const SHOW_LAST_PARKED_LOCATION_TYPE = 'SHOW_LAST_PARKED_LOCATION_TYPE';
export const SHOW_LAST_PARKED_LOCATION_NAME = 'SHOW_LAST_PARKED_LOCATION_NAME';
export const SHOW_BULK_ACTION = 'SHOW_BULK_ACTION';
export const SHOW_COMMENT_IN_MOVEMENT_CREATION =
  'SHOW_COMMENT_IN_MOVEMENT_CREATION';
export const SHOW_VENDOR_TYPE_FILTER = 'SHOW_VENDOR_TYPE_FILTER';
export const SHOW_VENDOR_NAME_FILTER = 'SHOW_VENDOR_NAME_FILTER';
export const DEFAULT_OPEN_INVENTORY_SEARCH = 'DEFAULT_OPEN_INVENTORY_SEARCH';
export const DEFAULT_OPEN_LOGISTIC_SEARCH = 'DEFAULT_OPEN_LOGISTIC_SEARCH';
export const USE_FUZZY_SEARCH_IN_APT_ID = 'USE_FUZZY_SEARCH_IN_APT_ID';
export const USE_FUZZY_SEARCH_IN_VIN = 'USE_FUZZY_SEARCH_IN_VIN';
export const USE_FUZZY_SEARCH_IN_STOCK_ID = 'USE_FUZZY_SEARCH_IN_STOCK_ID';
export const ENABLE_DATE_PICKER_SELECTION_BY_TYPING =
  'ENABLE_DATE_PICKER_SELECTION_BY_TYPING';
export const SHOW_CONFIGURATIONS_MENU = 'SHOW_CONFIGURATIONS_MENU';
export const SHOW_SCHEDULED_TASKS_MENU = 'SHOW_SCHEDULED_TASKS_MENU';
export const SHOW_INVENTORY_TYPE_REMARKS = 'SHOW_INVENTORY_TYPE_REMARKS';
export const SHOW_DP_BANK_STATUS = 'SHOW_DP_BANK_STATUS';
export const SHOW_MAPPED_MRL = 'SHOW_MAPPED_MRL';
export const SHOW_ACCEPTING_INCOMING_LOGISTICS =
  'SHOW_ACCEPTING_INCOMING_LOGISTICS';
export const SHOW_STORE_IMG_LINK = 'SHOW_STORE_IMG_LINK';
export const SHOW_BARCODE_IN_PARKING_SLOT = 'SHOW_BARCODE_IN_PARKING_SLOT';
export const SHOW_PAYTM_WALLET = 'SHOW_PAYTM_WALLET';
export const SHOW_REGIONAL_PAYTM_FUEL_WALLET =
  'SHOW_REGIONAL_PAYTM_FUEL_WALLET';
export const SHOW_ON_ROAD_PRICE = 'SHOW_ON_ROAD_PRICE';
export const SHOW_MOVEMENT_TYPE_IN_SET_LOGISTICS =
  'SHOW_MOVEMENT_TYPE_IN_SET_LOGISTICS';
export const SHOW_RESERVED_STATUS = 'SHOW_RESERVED_STATUS';
export const SHOW_CUSTOMER_RETURN = 'SHOW_CUSTOMER_RETURN';
export const SHOW_SERVICEABLE_AREA = 'SHOW_SERVICEABLE_AREA';
export const SHOW_ORDER_ID = 'SHOW_ORDER_ID';
export const SHOW_DRIVER_TYPE = 'SHOW_DRIVER_TYPE';
export const SHOW_DRIVER_PAN = 'SHOW_DRIVER_PAN';
export const SHOW_USER_PREFERENCES_TAB = 'SHOW_USER_PREFERENCES_TAB';
export const SHOW_ASSORTMENT_TYPE = 'SHOW_ASSORTMENT_TYPE';
export const SHOW_OFFLINE_DISCOUNT = 'SHOW_OFFLINE_DISCOUNT';
export const SHOW_NUMBER_PLATE = 'SHOW_NUMBER_PLATE';
export const SHOW_PARENT_HUB = 'SHOW_PARENT_HUB';
export const SHOW_REASON_IN_AUDIT_TRAIL = 'SHOW_REASON_IN_AUDIT_TRAIL';
export const SHOW_ADDITIONAL_REASONS = 'SHOW_ADDITIONAL_REASONS';
export const SHOW_INDIA_KEY_MANAGEMENT_TAB = 'SHOW_INDIA_KEY_MANAGEMENT_TAB';
export const SHOW_CATALOG_FLAG = 'SHOW_CATALOG_FLAG';
export const SHOW_LOCATION_DISPLAY_NAME = 'SHOW_LOCATION_DISPLAY_NAME';
export const SHOW_PSEUDO_STATUS = 'SHOW_PSEUDO_STATUS';
export const SHOW_CHASSIS_IMPRINT = 'SHOW_CHASSIS_IMPRINT';
export const SHOW_UPCOMING_STATUS = 'SHOW_UPCOMING_STATUS';
export const SHOW_INVENTORY_STATUS_REASON = 'SHOW_INVENTORY_STATUS_REASON';

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
